/*
 * No.9 Caffè — footer newsletter.
 *
 * Posts with fetch instead of a normal submit. A normal submit reloads the page
 * and lands the shopper on ?customer_posted=true#<form id>, and that flag makes
 * form.posted_successfully? read true for EVERY customer form on the page — so
 * this signup would also fire the "notify me" dialog's success state. Posting in
 * the background leaves the URL alone and keeps the forms independent.
 *
 * Delegated from the document so it survives section re-renders in the editor.
 */
(function () {
  if (window.__no9FooterNewsletter) return;
  window.__no9FooterNewsletter = true;


  /*
   * Klaviyo client-side subscription.
   *
   * Uses the public /client/subscriptions endpoint, which is designed for the
   * browser and takes the public site ID — no private key is ever exposed.
   *
   * Consent is NOT sent in the payload: this endpoint rejects a 'subscriptions'
   * block and instead derives consent from the list's own opt-in process. The
   * target list is single opt-in, so a successful call records the profile as
   * SUBSCRIBED with a consent timestamp. If that list is ever switched to double
   * opt-in, Klaviyo will send the confirmation email instead, which is the
   * correct behaviour and needs no change here.
   */
  function subscribeKlaviyo(form) {
    var listEl = form.querySelector('[data-klaviyo-list]');
    var companyEl = form.querySelector('[data-klaviyo-company]');
    var emailEl = form.querySelector('input[type="email"]');
    if (!listEl || !companyEl || !emailEl) return;

    var list = listEl.value;
    var company = companyEl.value;
    var email = (emailEl.value || '').trim();
    if (!list || !company || !email) return;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer newsletter (No.9 storefront)',
            profile: { data: { type: 'profile', attributes: { email: email } } },
          },
          relationships: { list: { data: { type: 'list', id: list } } },
        },
      }),
    }).catch(function () {
      /* Shopify still has the address; nothing useful to show the shopper. */
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.ft-no9__nl-form');
    if (!form) return;

    e.preventDefault();

    var field = form.querySelector('[data-nl-field]');
    var success = form.querySelector('[data-nl-success]');
    var button = form.querySelector('.ft-no9__field-btn');
    if (button) button.disabled = true;

    // Klaviyo is what the email flows run on, so subscribe there as well as
    // creating the Shopify customer. Fired in parallel and deliberately not
    // awaited: a Klaviyo hiccup must never stop the shopper seeing success for
    // a signup Shopify already captured.
    subscribeKlaviyo(form);

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
    })
      .then(function () {
        // The address is captured even when Shopify answers with a duplicate-
        // customer notice, so anything short of a network failure counts as
        // success from the shopper's point of view.
        if (field) field.hidden = true;
        if (success) success.hidden = false;
      })
      .catch(function () {
        // Network failure — let the browser do it the ordinary way rather than
        // silently swallowing the signup.
        if (button) button.disabled = false;
        form.submit();
      });
  });
})();
